import clsx from "clsx"
import { cartWidthClassName } from "./CartProductImage"

export const CartProductImagePlaceholder = () => {
  return <div className={clsx(cartWidthClassName, "invisible")} />
}
